
export class Admins {
  private id: number;
  private name: string;
  private email: string;
  private profiles_id: string;
  private profiles_name: string;
  private token: string;
  private is_delete: boolean;

  constructor(Admins: any) {
    this.id = Admins.id;
    this.name = Admins.name;
    this.email = Admins.email;
    this.profiles_id = (Admins.profiles != undefined) ? Admins.profiles.id : 1;
    this.profiles_name = (Admins.profiles != undefined) ? Admins.profiles.libelle : 1;
    this.token = Admins.token;
    this.is_delete = Admins.isDelete;
  }

  getId(): number {
    return this.id;
  }

  getName(): string {
    return this.name;
  }

  getEmail(): string {
    return this.email;
  }

  getProfilesId(): string {
    return this.profiles_id;
  }

  getProfilesName(): string {
    return this.profiles_name;
  }

  getToken(): string {
    return this.token;
  }

  getIsDelete(): boolean {
    return this.is_delete;
  }

}